import type { ReactElement } from 'react';

import { cn } from '@/app/components/ui/utils';

interface LoadingFallbackProps {
  /** Minimum height to prevent layout shift */
  minHeight?: string;
  /** Additional CSS classes */
  className?: string;
}

/**
 * Lightweight loading component for Suspense boundaries.
 * Displays a centered spinner with configurable minimum height to prevent CLS.
 */
export function LoadingFallback({ 
  minHeight = '100vh',
  className 
}: LoadingFallbackProps): ReactElement {
  return (
    <div 
      className={cn(
        'flex items-center justify-center bg-background',
        className
      )}
      style={{ minHeight }}
      role="status"
      aria-label="Loading page content"
    >
      <div className="flex flex-col items-center gap-4">
        {/* Animated spinner using CSS */}
        <div 
          className="size-10 border-4 border-foreground/20 border-t-brand-sienna rounded-full animate-spin"
          aria-hidden="true"
        />
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
}
